var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 359.082L1403.12 817.243V993.962H22.5V359.082Z",
    fill: "#98765D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 361.813L1440 839.68V1024H0V361.813Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297 449.194L1143 730.003V838.314H297V449.194Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 1164.88,
    x2: 1164.88,
    y2: 1024,
    stroke: "#D7CAC0",
    strokeDasharray: "6 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 737.375,
    x2: 737.375,
    y2: 1024,
    stroke: "#D7CAC0",
    strokeDasharray: "6 6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 309.875,
    x2: 309.875,
    y2: 1024,
    stroke: "#D7CAC0",
    strokeDasharray: "6 6"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 951.125,
    x2: 951.125,
    y2: 1024,
    stroke: "#D7CAC0",
    strokeDasharray: "6 6"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 523.625,
    x2: 523.625,
    y2: 1024,
    stroke: "#D7CAC0",
    strokeDasharray: "6 6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 96.125,
    x2: 96.125,
    y2: 1024,
    stroke: "#D7CAC0",
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.e7e5d209a23c3a6a14f0de7f83cb1367.svg";
export { ForwardRef as ReactComponent };